export const apiUrl = function() {
    if (location.hostname === 'localhost') {
        return 'http://localhost:3000/';
    } else if (location.hostname === 'staging.my247ed.com') {
        return 'https://staging-api.my247ed.com/';
    } else {
        return '/';
    }
}();
